import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ShoppingCartService } from '@app/core/services/shopping-cart.service';
import { State, Store } from '@ngrx/store';
import { AppState, FramesCartActionTypes } from '@app/core/ngrx';
import { PhoneValidator } from '@app/shared/validators/phone.validator';
import { NotificationService } from '@app/core/services';

@Component({
  selector: 'ecp-my-cart',
  templateUrl: './my-cart.component.html',
  styleUrls: ['./my-cart.component.scss'],
})
export class MyCartComponent implements OnInit, AfterViewInit {
  @ViewChild('stickyMenu') menuElement: ElementRef;

  isLoading: boolean;
  sticky = false;
  elementPosition: any;
  form: FormGroup;
  mask: any[] = [
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '-',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '-',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
  ];
  constructor(
    private fb: FormBuilder,
    private shoppingCartService: ShoppingCartService,
    private state: State<AppState>,
    private store: Store<AppState>,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    if (!this.form) {
      this.form = this.createForm();
    }
  }

  get firstName(): AbstractControl {
    return this.form.get('firstName');
  }

  get lastName(): AbstractControl {
    return this.form.get('lastName');
  }

  get email(): AbstractControl {
    return this.form.get('email');
  }

  get phoneNumber(): AbstractControl {
    return this.form.get('phoneNumber');
  }
  createForm(): FormGroup {
    return this.fb.group({
      firstName: ['', [Validators.required, this.noWhitespaceValidator]],
      lastName: ['', [Validators.required, this.noWhitespaceValidator]],
      phoneNumber: ['', [Validators.required, PhoneValidator]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    this.isLoading = true;
    let value = this.form.value;
    let stateValue = this.state.getValue();
    value.frames = stateValue.framesCart.framesCart; // .framesCart.map(frame => frame.fpc);
    this.shoppingCartService
      .submitFrameOrder(value, stateValue.user.patientID)
      .subscribe(
        (resp: any) => {
          this.store.dispatch({
            type: FramesCartActionTypes.CLEAR_FRAMES_CART,
          });
          this.isLoading = false;
          let notificationOptions = {
            title: 'Success',
            contentHtml:
              'Successfully sent "My Favorites" to ' +
              stateValue.user.profile.businessName,
            confirmBtnText: 'Close',
          };
          this.notificationService.error(notificationOptions);
        },
        err => (this.isLoading = false),
        () => {
          // TODO - Add a success submitted cart popup dialog
        },
      );
  }

  ngAfterViewInit() {
    this.elementPosition = this.menuElement.nativeElement.offsetTop;
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    this.sticky = windowScroll >= this.elementPosition;
  }

  private noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
}
